/*
 * DTFNY · Featured collection carousel
 *
 * Lightweight scroll-snap carousel with arrow buttons, progress bar,
 * and position counter. Uses native CSS scroll-snap for buttery scrolling,
 * works with touch/swipe out of the box, and falls back to plain grid
 * when the carousel isn't needed.
 *
 * Markup contract (rendered by sections/dtfny-featured-collection.liquid):
 *   <element data-dtfny-fc-carousel>
 *     <element data-dtfny-fc-track>
 *       <element data-dtfny-fc-card>...</element> (one per product)
 *     </element>
 *     <button data-dtfny-fc-prev>...</button>
 *     <button data-dtfny-fc-next>...</button>
 *     <element data-dtfny-fc-progress>
 *       <span data-dtfny-fc-progress-fill></span>
 *     </element>
 *     <element data-dtfny-fc-counter>
 *       <span data-dtfny-fc-counter-current></span> /
 *       <span data-dtfny-fc-counter-total></span>
 *     </element>
 *   </element>
 */
(function () {
  function init(root) {
    var track = root.querySelector('[data-dtfny-fc-track]');
    var prev = root.querySelector('[data-dtfny-fc-prev]');
    var next = root.querySelector('[data-dtfny-fc-next]');
    var fill = root.querySelector('[data-dtfny-fc-progress-fill]');
    var current = root.querySelector('[data-dtfny-fc-counter-current]');
    var total = root.querySelector('[data-dtfny-fc-counter-total]');
    if (!track) return;

    var cards = track.querySelectorAll('[data-dtfny-fc-card]');
    if (total) total.textContent = String(cards.length);

    function visibleCount() {
      if (!cards.length) return 1;
      var trackRect = track.getBoundingClientRect();
      var count = 0;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        if (r.left >= trackRect.left - 1 && r.right <= trackRect.right + 1) count++;
      }
      return Math.max(1, count);
    }

    function step() {
      if (!cards.length) return track.clientWidth;
      var card = cards[0];
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? (track.scrollLeft / max) * 100 : 100;
      if (fill) fill.style.width = pct + '%';

      if (current && cards.length) {
        var firstVisible = 0;
        var trackLeft = track.getBoundingClientRect().left;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].getBoundingClientRect().left >= trackLeft - 1) {
            firstVisible = i;
            break;
          }
        }
        current.textContent = String(firstVisible + 1);
      }

      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step() * visibleCount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step() * visibleCount(), behavior: 'smooth' });
      });
    }

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        update();
      });
    });

    window.addEventListener('resize', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        update();
      });
    });

    update();
  }

  function bootstrap() {
    document.querySelectorAll('[data-dtfny-fc-carousel]').forEach(function (el) {
      if (el.dataset.dtfnyFcInit) return;
      el.dataset.dtfnyFcInit = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', bootstrap);

  // Watch for AJAX-loaded carousels (e.g. <product-recommendations>) — throttled via rAF
  var bootstrapScheduled = false;
  function scheduleBootstrap() {
    if (bootstrapScheduled) return;
    bootstrapScheduled = true;
    requestAnimationFrame(function () {
      bootstrap();
      bootstrapScheduled = false;
    });
  }
  if ('MutationObserver' in window && document.body) {
    var bodyObserver = new MutationObserver(scheduleBootstrap);
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
